import React, { useState } from "react";

import Message from "../../Message";
import SuccessRes from "../SuccessRes";
import { updateTransferSchema } from "../../../../joi/transferSchema";
import { updateTransferSetData } from "../../../../../context/api/transfers/update-transfer/updateTransferSetData";
import { useValidator } from "react-joi";
import { useCookies } from "react-cookie";
import { joiErrorMessage } from "../../../extra/joiErrorMessage";
// Bootstrap
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import Modal from "react-bootstrap/Modal";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";

const UpdateTransferModal = ({
  show,
  onHide,
  lang,
  dataTranslate,
  setRefreshData,
  data,
}) => {
  var schema = updateTransferSchema(lang).schema;

  const initialMessageRes = {
    success: Boolean,
    message: String,
    isShow: false,
  };

  const initialSuccessMessage = {
    success: false,
    type: "",
    data: {},
  };

  const { state, setData, setExplicitField, validate, reset } =
    useValidator(schema);
  const [messageResponse, setMessageResponse] = useState(initialMessageRes);
  const [successMessage, setSuccessMessage] = useState(initialSuccessMessage);
  const [cookies] = useCookies();
  const [btnLoader, setBtnLoader] = useState(false);

  const updateTransfer = (e) => {
    e.preventDefault();
    const transferId = data.id;
    let credintial = {};
    for (const item in state.$data) {
      if (state.$data[item] != null) {
        credintial[item] = state.$data[item];
      }
    }
    // remove any empty value
    for (const item in credintial) {
      if (state.$data[item] === "") {
        delete credintial[item];
      }
    }

    if (state.$all_source_errors.length < 1) {
      setBtnLoader(() => true);
      return updateTransferSetData(
        lang,
        setMessageResponse,
        cookies,
        transferId,
        credintial,
        setSuccessMessage,
        setBtnLoader
      );
    }
  };

  return (
    <>
      <Message
        messageResponse={messageResponse}
        close={() => setMessageResponse(initialMessageRes)}
        lang={lang}
      />

      <Modal
        show={show}
        onHide={onHide}
        backdrop="static"
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="forget-pass-otp-form"
        dir={lang === "AR" ? "rtl" : "ltr"}
      >
        {successMessage.success ? (
          <SuccessRes
            lang={lang}
            dataTranslate={dataTranslate}
            onHide={async () => {
              await onHide();
              setSuccessMessage(initialSuccessMessage);
              setRefreshData((prev) => prev + 1);
            }}
            res={successMessage}
          />
        ) : (
          <>
            <Modal.Header className="d-flex align-items-center justify-content-center ">
              <Modal.Title
                id="contained-modal-title-vcenter"
                className="fs-2 d-flex flex-row gap-2"
              >
                <span>{dataTranslate.popups.create_transfer.update_title}</span>
                <span style={{ color: "red" }}>{data.id}</span>
              </Modal.Title>
            </Modal.Header>

            <Modal.Body className="mx-5">
              <div dir={lang === "AR" ? "rtl" : ""}>
                <Container>
                  <Row className="mb-lg-3">
                    <Col lg={4} sm={12} className="mb-3 mb-lg-0">
                      <Form.Group>
                        <Form.Label>
                          {dataTranslate.popups.create_transfer.amount}
                          <span>
                            <sup style={{ color: "red" }}> *</sup>
                          </span>
                        </Form.Label>
                        <Form.Control
                          defaultValue={data.totalAmount}
                          onChange={(e) => {
                            setData((old) => ({
                              ...old,
                              totalAmount: e.target.value,
                            }));
                          }}
                          onBlur={() => setExplicitField("totalAmount", true)}
                        />
                      </Form.Group>

                      <Form.Text style={{ color: "red" }}>
                        {joiErrorMessage(state.$errors.totalAmount)}
                      </Form.Text>
                    </Col>

                    <Col lg={4} sm={12} className="mb-3 mb-lg-0">
                      <Form.Group>
                        <Form.Label>
                          {dataTranslate.popups.create_transfer.fees}
                          <span>
                            <sup style={{ color: "red" }}> *</sup>
                          </span>
                        </Form.Label>
                        <Form.Control
                          type="number"
                          defaultValue={data.feesRates}
                          onChange={(e) => {
                            setData((old) => ({
                              ...old,
                              feesRates: e.target.value,
                            }));
                          }}
                          onBlur={() => setExplicitField("feesRates", true)}
                        />
                      </Form.Group>

                      <Form.Text style={{ color: "red" }}>
                        {joiErrorMessage(state.$errors.feesRates)}
                      </Form.Text>
                    </Col>

                    <Col lg={4} sm={12} className="mb-3 mb-lg-0">
                      <Form.Group>
                        <Form.Label>
                          {dataTranslate.popups.create_transfer.currency.title}
                          <span>
                            <sup style={{ color: "red" }}> *</sup>
                          </span>
                        </Form.Label>
                        <Form.Select
                          defaultValue={data.currencyISO}
                          onChange={(e) => {
                            setData((old) => ({
                              ...old,
                              currency: e.target.value,
                            }));
                          }}
                          onBlur={() => setExplicitField("currency", true)}
                        >
                          <option selected>
                            {dataTranslate.popups.create_transfer.select}
                          </option>
                          <option value="840">
                            {dataTranslate.popups.create_transfer.currency.usd}
                          </option>
                          <option value="156">
                            {dataTranslate.popups.create_transfer.currency.rmb}
                          </option>
                        </Form.Select>
                      </Form.Group>

                      <Form.Text style={{ color: "red" }}>
                        {joiErrorMessage(state.$errors.currency)}
                      </Form.Text>
                    </Col>
                  </Row>

                  <Row className="mb-lg-3">
                    <Col lg={12} sm={12} className="mb-3 mb-lg-0">
                      <Form.Group>
                        <Form.Label>
                          {dataTranslate.popups.create_transfer.notes}
                        </Form.Label>
                        <Form.Control
                          as="textarea"
                          defaultValue={data.NB}
                          onChange={(e) => {
                            setData((old) => ({
                              ...old,
                              NB: e.target.value,
                            }));
                          }}
                          onBlur={() => setExplicitField("NB", true)}
                        />
                      </Form.Group>

                      <Form.Text style={{ color: "red" }}>
                        {joiErrorMessage(state.$errors.NB)}
                      </Form.Text>
                    </Col>
                  </Row>
                </Container>
              </div>
            </Modal.Body>
            <Modal.Footer
              className="w-100 d-flex flex-row align-items-center"
              dir="ltr"
            >
              <div className="w-100 double-btns d-flex flex-row align-items-center justify-content-center gap-2">
                <Button
                  onClick={(e) => {
                    validate();
                    updateTransfer(e);
                  }}
                  disabled={btnLoader ? true : false}
                >
                  {dataTranslate.popups.create_transfer.update}
                </Button>

                <Button
                  onClick={() => {
                    reset();
                    onHide();
                  }}
                >
                  {dataTranslate.popups.create_transfer.close}
                </Button>
              </div>
            </Modal.Footer>
          </>
        )}
      </Modal>
    </>
  );
};

export default UpdateTransferModal;
